import axiosInstance from "@/api/axios-instance";

export async function markUnsuccessful(source_id: string, reason: string) {
  const response = await axiosInstance.post(`/sessions/mark-unsuccessful`, {
    source_id,
    reason,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to mark session as unsuccessful");
  }

  return response.data;
}

export async function unmarkUnsuccessful(source_id: string) {
  const response = await axiosInstance.post(`/sessions/unmark-unsuccessful`, {
    source_id,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to unmark session as unsuccessful");
  }

  return response.data;
}
